import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {Alert, CardBody, CardTitle, Col, Container, Form, FormFeedback, Input, Label, Row, Table,} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {useFormik} from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";

import Breadcrumbs from "../../components/Common/Breadcrumb";

import {
  getOrgSsoStatus,
  inviteConfirmation,
  inviteConfirmation as onInviteConfirmation
} from "../../store/inviteconfirmation/actions";
import {useParams} from "react-router";
import Card from "components/PurpleTheme/Card";

const InviteConfirmation = (props) => {
  //meta title
  document.title = "Invite Confirmation | Temperstack";

  const dispatch = useDispatch();

  const params = useParams()

  let navigate = useNavigate();

  useEffect(() => {
    dispatch(getOrgSsoStatus())
  }, []);

  const {invite_success_message} = useSelector(state => ({
    invite_success_message: state.InviteConfirmation.invite_success_message,
  }));

  const {org_sso_only} = useSelector(state => ({
    org_sso_only: state.InviteConfirmation.org_sso_only,
  }));

  const {invite_error_message} = useSelector(state => ({
    invite_error_message: state.InviteConfirmation.invite_error_message,
  }));
  const passwordValidationSchema = Yup.string()
    .required("Please enter the password")
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Password must contain uppercase letters")
    .matches(/[a-z]/, "Password must contain lowercase letters")
    .matches(/\d/, "Password must contain numbers")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "Password must contain special characters")

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      password: ''
    },
    validationSchema: Yup.object({
      password: passwordValidationSchema
    }),
    onSubmit: (values) => {
      if (!validation.isValid) return;
      let payload = {
        token: params.token,
        password: values.password,
        history: navigate
      }
      dispatch(inviteConfirmation(payload));
    },
  });

  useEffect(() => {
    if(org_sso_only){
      let payload = {
        token: params.token,
        history: navigate,
        password: null
      }
      dispatch(inviteConfirmation(payload));
    }
  }, [org_sso_only]);

  return (
    <React.Fragment>
      <div className="my-5 pt-sm-5">
        {org_sso_only ? (
          <>
            <Container style={{marginTop:"15%"}}>
              <div className={'d-flex flex-column justify-content-center'}>
                <div className='d-flex justify-content-center'>
                  <h4 style={{marginRight:'1%'}}><i className="mdi mdi-check-circle text-success" /></h4>
                  <h4>
                    Email Confirmed
                  </h4>
                </div>
                <div className={'d-flex justify-content-center'}>
                  Redirecting you to login page ...
                </div>
              </div>
            </Container>
          </>
        ):(
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5} className="mt-5">
                <Card className="overflow-hidden">
                  <div>
                    <Row>
                      <h3 className="p-4 pb-2">Set a Password</h3>
                      <p className="p-4 pt-0">Please choose a password you'd like to use for your account</p>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <Form
                      className="form-horizontal mt-1"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                      }}
                    >
                      {invite_error_message ? <Alert color="danger">{invite_error_message}</Alert> : null}
                      {invite_success_message ? <Alert color="success">{invite_success_message}.. Redirecting you to login</Alert> : null}
                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          className="form-control"
                          placeholder="Password"
                          type="password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            validation.touched.password && validation.errors.password ? true : false
                          }
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button className="btn btn-primary w-md " type="submit">
                            Submit
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

InviteConfirmation.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
};

export default withRouter(InviteConfirmation);